import { SxProps } from '@mui/material';
import { BrushboxProps, BrushboxVariants } from './Brushbox.interfaces';

export const brushBoxContainerStyles = (sx?: SxProps): SxProps => ({
  ...sx,
  position: 'relative',
})

export const imageSxProps = ({
  variant,
}: Pick<BrushboxProps, 'variant'>): SxProps => ({
  position: 'absolute',
  zIndex: -1,
  top: 0,
  left: variant === BrushboxVariants.Wide ? '50%' : 0,
  transform: variant === BrushboxVariants.Wide ? 'translateX(-50%)' : 'none',
  width: variant === BrushboxVariants.Wide ? '125vw' : '100%',
  height: '100%',
});
